// (function () {
//   var views = ['listv', 'gridv', 'galleryv', 'twogrid'];
//   var gridClass = { listv: 'product-list', gridv: 'product-grid', galleryv: 'product-gallery', twogrid: 'product-twogrid' };

//   function viewOf(el) {
//     for (var i = 0; i < views.length; i++) if (el.classList.contains(views[i])) return views[i];
//   }

//   function layoutOf(grid) {
//     if (!grid) return;
//     for (var i = 0; i < views.length; i++) if (grid.classList.contains(gridClass[views[i]])) return views[i];
//   }

//   function shown(el) {
//     return el && el.offsetParent;
//   }

//   function activeView(layout, wrap) {
//     var btn = wrap.querySelector('.wblistgridbtn.' + layout);
//     if (shown(btn)) return layout;
//     if (layout === 'galleryv') {
//       btn = wrap.querySelector('.wblistgridbtn.gridv');
//       if (shown(btn)) return 'gridv';
//     }
//     if (layout === 'gridv' || layout === 'galleryv') {
//       btn = wrap.querySelector('.wblistgridbtn.twogrid');
//       if (shown(btn)) return 'twogrid';
//     }
//     var btns = wrap.querySelectorAll('.wblistgridbtn');
//     for (var i = 0; i < btns.length; i++) if (shown(btns[i])) return viewOf(btns[i]) || layout;
//     return layout;
//   }

//   function sync(view) {
//     var layout = view || layoutOf(document.getElementById('product-grid'));
//     if (!layout) return;
//     document.querySelectorAll('.wbglbtn').forEach(function (wrap) {
//       var active = activeView(layout, wrap);
//       wrap.querySelectorAll('.wblistgridbtn').forEach(function (btn) {
//         btn.classList.remove('active_tab');
//         btn.classList.toggle('active', btn.classList.contains(active));
//       });
//     });
//   }

//   function apply(view) {
//     var grid = document.getElementById('product-grid');
//     if (!grid || !gridClass[view]) return;
//     grid.classList.remove('product-list', 'product-grid', 'product-gallery', 'product-twogrid');
//     grid.classList.add(gridClass[view]);
//   }

//   sync();
//   document.addEventListener('click', function (e) {
//     var btn = e.target.closest('.wblistgridbtn');
//     if (!btn) return;
//     var view = viewOf(btn);
//     if (!view) return;
//     apply(view);
//     sync(view);
//   });
//   document.addEventListener('shopify:section:load', sync);
//   var resizeTimer;
//   window.addEventListener('resize', function () {
//     clearTimeout(resizeTimer);
//     resizeTimer = setTimeout(sync, 150);
//   });
// })();

const LAYOUT_KEY = 'wb-collection-layout';
const GRID = { listv: 'product-list', gridv: 'product-grid', galleryv: 'product-gallery', twogrid: 'product-twogrid' };
const PROXY = { gridv: 'twogrid', galleryv: 'gridv' };
const mqT = matchMedia('(max-width: 991px)');
const mqM = matchMedia('(max-width: 767px)');

const getLayout = (el) => ['listv', 'gridv', 'galleryv', 'twogrid'].find((c) => el?.classList.contains(c));
const isHidden = (el) => (mqM.matches && el.classList.contains('small-hide')) || (mqT.matches && el.classList.contains('medium-hide'));

function pickToggle(group, layout) {
  let el = group.querySelector(`.wblistgridbtn.${layout}`);
  if (el && !isHidden(el)) return el;
  if (!mqT.matches) return el;
  const proxy = PROXY[layout] && group.querySelector(`.wblistgridbtn.${PROXY[layout]}`);
  if (proxy && !isHidden(proxy)) return proxy;
  for (el = el?.nextElementSibling; el; el = el.nextElementSibling) {
    if (el.classList.contains('wblistgridbtn') && !isHidden(el)) return el;
  }
  return group.querySelector('.wblistgridbtn:not(.small-hide):not(.medium-hide)') || el;
}

function syncToggles(layout) {
  document.querySelectorAll('.wblistgridbtn.active, .wblistgridbtn.active_tab').forEach((b) => b.classList.remove('active', 'active_tab'));
  document.querySelectorAll('.wbglbtn').forEach((group) => {
    const btn = pickToggle(group, layout);
    if (!btn) return;
    btn.classList.add('active');
    const galleryBtn = group.querySelector('.wblistgridbtn.galleryv');
    if (layout === 'galleryv' && btn.classList.contains('gridv') && galleryBtn && isHidden(galleryBtn)) {
      btn.classList.add('active_tab');
    }
  });
}

function applyLayout(layout) {
  if (!GRID[layout]) return;
  syncToggles(layout);
  const grid = document.getElementById('product-grid');
  if (!grid) return;
  grid.classList.remove(...Object.values(GRID));
  grid.classList.add(GRID[layout]);
}

function applyActiveGridLayout() {
  let layout;
  try { layout = localStorage.getItem(LAYOUT_KEY); } catch (e) {}
  if (!GRID[layout] || !document.querySelector(`.wblistgridbtn.${layout}`)) {
    layout = getLayout(document.querySelector('.wblistgridbtn.active, .wblistgridbtn.active_tab'));
  }
  if (layout) applyLayout(layout);
}

function initGridLayout() {
  if (document.getElementById('product-grid')) applyActiveGridLayout();
}

if (!window.__wbGridLayout) {
  window.__wbGridLayout = true;
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.wblistgridbtn');
    const layout = getLayout(btn);
    if (!layout || !document.getElementById('product-grid')) return;
    try { localStorage.setItem(LAYOUT_KEY, layout); } catch (e) {}
    applyLayout(layout);
  });
  mqT.addEventListener('change', () => {
    let layout;
    try { layout = localStorage.getItem(LAYOUT_KEY); } catch (e) {}
    if (GRID[layout]) syncToggles(layout);
  });
}

document.addEventListener('shopify:section:load', initGridLayout);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGridLayout);
else initGridLayout();

// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

// TIMER

setInterval(countDown, 1000);
function countDown() {
  const countCardSections = document.querySelectorAll('.timer_wrap');
  countCardSections.forEach((countdownSection) => {
  var countDownDate = new Date(countdownSection.getAttribute('data-date')).getTime();
  var now = new Date().getTime();
  var distance = countDownDate - now;
  if (distance < 0 || isNaN(countDownDate)) {
    countdownSection.querySelector('.timer_days').textContent = "00";
    countdownSection.querySelector('.timer_hours').textContent = "00";
    countdownSection.querySelector('.timer_minutes').textContent = "00";
    countdownSection.querySelector('.timer_seconds').textContent = "00";
  } else {
    countdownSection.querySelector('.timer_days').textContent = addLeadingZero(Math.floor(distance / (1000 * 60 * 60 * 24)));
    countdownSection.querySelector('.timer_hours').textContent = addLeadingZero(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
    countdownSection.querySelector('.timer_minutes').textContent = addLeadingZero(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
    countdownSection.querySelector('.timer_seconds').textContent = addLeadingZero(Math.floor((distance % (1000 * 60)) / 1000));
  }
  });
}
function addLeadingZero(number) {
  return number < 10 ? "0" + number : number;
}